import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const slides = [
    {
        image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1470&auto=format&fit=crop',
        title: 'A great place to work is for everyone',
        paragraphs: [
            "Unlike regular job sites, Half The Sky works directly with companies to assess their career benefits and commitment to women in the workplace as well as provide transparency on a company's success rate when it comes to diversify and inclusion.",
            "We make the whole process of finding your next best career move more transparent using our benchmarking tools."
        ],
        link: '/register'
    },
    {
        image: 'https://images.unsplash.com/photo-1573496130407-57329f01f769?q=80&w=1469&auto=format&fit=crop',
        title: 'Diversity & Inclusion in the workplace matters',
        paragraphs: [
            "We believe that creating and/or further instilling a diverse workforce benefits everyone. The best organizations thrive by enabling their people the opportunity to be celebrated for their uniqueness and differences.",
            "We're working everyday to encourage more organizations to adopt better ways they can find, hire, retain and promote more diverse talents."
        ],
        link: '/register'
    },
    {
        image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=1632&auto=format&fit=crop',
        title: 'Levelling the playing field',
        paragraphs: [
            "As the leading career platform for women in Asia, we hope to increase female representation at every level. The companies we work with are committed to growing women leadership representation in their organizations and help women prepare for the future of work.",
            "Join us on our mission as we help you find great jobs, coaching, training and a community that suits you."
        ],
        link: '/register'
    }
];

const ValuesCta = () => {
    const [current, setCurrent] = useState(0);

    const handlePrev = () => {
        setCurrent(current === 0 ? slides.length - 1 : current - 1);
    };

    const handleNext = () => {
        setCurrent(current === slides.length - 1 ? 0 : current + 1);
    };

    const { image, title, paragraphs, link } = slides[current];

    return (
        <section className="bg-white py-20">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center gap-12">
                    {/* Image Column */}
                    <div className="w-full lg:w-5/12">
                        <img 
                            src={image}
                            alt={title}
                            className="rounded-2xl shadow-xl w-full h-full object-cover aspect-square lg:aspect-auto"
                        />
                    </div>
                    {/* Text Column */}
                    <div className="w-full lg:w-7/12 text-center lg:text-left">
                        <h2 className="text-4xl font-bold text-gray-800 mb-6">{title}</h2>
                        {paragraphs.map((p, i) => (
                            <p key={i} className="text-lg text-gray-600 leading-relaxed mb-4">{p}</p>
                        ))}
                        <div className="mt-8">
                            <Link 
                                to={link}
                                className="inline-block bg-purple-700 text-white font-bold py-4 px-10 rounded-lg hover:bg-purple-800 transition-colors text-lg"
                            >
                                Join Us
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Navigation */}
                <div className="flex justify-center items-center mt-16 gap-4">
                    <button onClick={handlePrev} className="text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full">
                        <FaArrowLeft size={20} />
                    </button>
                    <div className="flex gap-3">
                        {slides.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setCurrent(i)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 ${current === i ? 'bg-purple-600' : 'bg-gray-300 hover:bg-gray-400'}`}
                            />
                        ))}
                    </div>
                    <button onClick={handleNext} className="text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full">
                        <FaArrowRight size={20} />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ValuesCta; 